const scrollSnapAlign = {
  name: "scroll-snap-align",
  path: "scroll-snap-align",
  title: "scroll-snap-align",
  description: "Utilities for controlling the CSS scroll-snap-align property.",
  value: {
    "scroll-snap-align": {
      "snap-start": "start",
      "snap-end": "end",
      "snap-center": "center",
      "snap-align-none": "none"
    }
  },
 exampleData: [
        {
            "title": "snap-center",
            "description": " utility to snap an element to its center when being scrolled inside a snap container:",
            "moreDescription": "",
            "parentClass": "relative flex w-full snap-x-mandatory gap-6 overflow-x-auto py-10 !bg-none !border-0",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-40 shrink-0 rounded-lg opacity-0",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-40 shrink-0 rounded-lg opacity-0",
                    },
                ],
                "className": "relative snap-center shrink-0",
                "code": `<div class="snap-x-mandatory ...">
  <div class="snap-center ...">
    <img src="/img/image-01.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-02.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-03.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-04.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-05.jpg" />
  </div>
  <div class="snap-center ...">
    <img src="/img/image-06.jpg" />
  </div>
</div>`
            }
        },
        {
            "title": "snap-start",
            "description": " utility to snap an element to its start when being scrolled inside a snap container:",
            "moreDescription": "",
            "parentClass": "relative flex w-full snap-x-mandatory gap-6 overflow-x-auto py-10 !bg-none !border-0",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-40 shrink-0 rounded-lg opacity-0",
                    },
                ],
                "className": "relative snap-start shrink-0",
                "code": `<div class="snap-x-mandatory ...">
  <div class="snap-start ...">
    <img src="/img/image-01.jpg" />
  </div>
  <div class="snap-start ...">
    <img src="/img/image-02.jpg" />
  </div>
  <div class="snap-start ...">
    <img src="/img/image-03.jpg" />
  </div>
  <div class="snap-start ...">
    <img src="/img/image-04.jpg" />
  </div>
  <div class="snap-start ...">
    <img src="/img/image-05.jpg" />
  </div>
  <div class="snap-start ...">
    <img src="/img/image-06.jpg" />
  </div>
</div>`
            }
        },
        {
            "title": "snap-end",
            "description": "  utility to snap an element to its end when being scrolled inside a snap container:",
            "moreDescription": "",
            "parentClass": "relative flex w-full snap-x-mandatory gap-6 overflow-x-auto py-10 !bg-none !border-0",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-10 shrink-0 rounded-lg opacity-0",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "h-40 w-80 shrink-0 rounded-lg",
                    },
                ],
                "className": "relative snap-end shrink-0",
                "code": `<div class="snap-x-mandatory ...">
  <div class="snap-end ...">
    <img src="/img/image-01.jpg" />
  </div>
  <div class="snap-end ...">
    <img src="/img/image-02.jpg" />
  </div>
  <div class="snap-end ...">
    <img src="/img/image-03.jpg" />
  </div>
  <div class="snap-end ...">
    <img src="/img/image-04.jpg" />
  </div>
  <div class="snap-end ...">
    <img src="/img/image-05.jpg" />
  </div>
  <div class="snap-end ...">
    <img src="/img/image-06.jpg" />
  </div>
</div>`
            }
        },
    ]
};

export default scrollSnapAlign;